export function requestNotifications() {
    return {
      type: 'REQUEST_NOTIFICATIONS',
    }
}